import { API_URL } from '../constants'

export const GET_CREDITS_V2         = `${API_URL}v2/credit/public/`
export const GET_CREDIT_V2          = (id: number) => `${API_URL}v2/credit/public/${id}`
export const GET_CALC_SIMPLE_V2     = (creditId: number, idplazo: number, amount: number) =>
    `${API_URL}v2/credit/public/calculatorSimple/${creditId}/${idplazo}/${amount}`
export const GET_CALC_FULL_V2       = (creditId: number, idplazo: number, amount: number) =>
    `${API_URL}v2/credit/public/calculator/${creditId}/${idplazo}/${amount}`
